import * as React from 'react';
import SummaryPanel from '../SummaryPanel/index';
import { IStockingProps } from '../interfaces';
import EnquiryGrid from 'components/common/EnquiryGrid';
import FormRenderer from 'components/common/DataGridDevEx/CustomRenderers/FormRenderer';

class Quantities extends React.PureComponent<IStockingProps> {
  componentDidMount(): void {
    const { path, onInitialLoad } = this.props;
    const routes = {
      '/inventory-enquiry/stocking/quantities/details': 'StockingQuantitiesPurchaseOrder',
      '/inventory-enquiry/stocking/quantities/details/orders/purchase-orders':
        'StockingQuantitiesPurchaseOrder'
    };

    onInitialLoad(routes[path] || 'StockingQuantities');
  }

  render(): React.ReactNode {
    const { selectedForm, path, onInitialLoad } = this.props;

    return (selectedForm &&
      <React.Fragment>
        <SummaryPanel
          variant={'ProductDetails'}
        />
        <EnquiryGrid
          path={path}
          onInitialLoad={onInitialLoad}
          customPopupContentRenderer={(data) => <FormRenderer {...data} />}
          program={{
            module: 'inventory',
            name: 'StockingQuantities',
            APIResponseKey: 'StockingQuantitiess',
            detailsPath: 'StockingQuantitiesPurchaseOrder',
            key: 'WarehouseLabel',
            requestMethod: 'GET',
            showInfoIcon: true,
          }}
        />
      </React.Fragment>
    );
  }
}

export default Quantities;
